import React, { Fragment, ReactNode } from 'react';

type CTAListProps = {
    data: Array<ReactNode>;
};

const CTAList = ({ data: ctaItems }: CTAListProps) => {
    return (
        <>
            {ctaItems.map((item, i) => {
                return <Fragment key={i}>{item}</Fragment>;
            })}
        </>
    );
};

export default CTAList;
